import { Component, Host, h, Prop, Element, State } from '@stencil/core'

@Component({
  tag: 'bam-cta-teaser',
})
export class BamCtaTeaser {
  @Element() host: HTMLBamCtaTeaserElement
  @Prop() headline?: string
  @Prop() width: 'full' | 'half' | 'third'
  @Prop() subtitle?: string
  @Prop() text?: string
  /**
   * Slotted teasers
   */
  @State() teasersList: HTMLBamCtaTeaserItemElement[]

  private classByWidth = {
    'full': 'is-full',
    'half': 'is-half',
    'third': 'is-one-third'
  }

  connectedCallback() {
    this.teasersList = Array.from(this.host.children) as HTMLBamCtaTeaserItemElement[]
    this.teasersList.map(teaser => {
        teaser.classList.add(this.classByWidth[this.width])
        if(this.width !== 'full') {
          if (teaser.querySelector('.cta-teaser-item__icon')) {
            teaser.querySelector('.cta-teaser-item__icon').classList.add('cta-teaser-item__icon--is-multicol')
          }
          if (teaser.querySelector('.cta-teaser-item__image')) {
            teaser.querySelector('.cta-teaser-item__image').classList.add('cta-teaser-item__image--is-multicol')
          }
        }
      }
    )
  }

  render() {
    return (
      <Host>
        {(this.headline || this.subtitle || this.text) &&
          <div class='bam-cta-teaser__headline mb-x-large'>
            <bal-heading level='h2' space='none'>{this.headline}</bal-heading>
            {this.subtitle && <bal-heading level='h4' space='top'>{this.subtitle}</bal-heading>}
            {this.text && <bal-text size='lead' space='top' bold={true}>{this.text}</bal-text>}
          </div>
        }
          <div class='grid is-multiline'>
            <slot></slot>
          </div>
      </Host>
    )
  }
}
